<template>
  <div class="allcontain">
    <!-- 顶部导航栏 -->
    <div class="topBar">
      <img src="../assets/image/logo.jpg" alt="" class="logo" />
      <div class="title">灵动配音</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'topBar',
  props: {
  }
}
</script>

<style scoped lang="less">
.allcontain {
  width: 100%;
  height: 70px;
  background-color: #ffffff;
  border-bottom: 1px solid #bfc1c5;
  color: #000000;

  .logo {
    width: 70px;
    height: auto;
  }
.title{
  margin-left: 10px;
}
  .topBar {
    width: 1900px;
    height: 70px;
    display: flex;
    border-bottom: 1px solid #bfc1c5;
    line-height: 70px;
    font-size: 18px;
    margin-left: 300px;
  }

}
</style>
